// 파일 경로: components/Global-Network-Observer.tsx (이름 예시)

"use client";

import { useEffect, useRef } from "react";
import { useNetworkStore } from "@/lib/store/useNetworkStore";
import { WifiOff } from "lucide-react";

/**
 * 앱의 전역 네트워크 상태를 감지하고,
 * 상태에 따라 UI 피드백(토스트, 상단 바)을 제공하는 통합 컴포넌트.
 */
export default function GlobalNetworkObserver() {
  // 1. Zustand 스토어에서 상태와 액션을 모두 가져옵니다.
  const { isOnline, setOnline, setOffline } = useNetworkStore();
  const firstLoad = useRef(true);

  // 2. [책임 1] 전역 이벤트를 감지하여 Zustand 상태를 업데이트합니다.
  useEffect(() => {
    const handleOnline = () => setOnline();
    const handleOffline = () => setOffline();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [setOnline, setOffline]);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
  }, [isOnline]);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-red-500 text-white text-sm font-semibold p-2 z-50 flex items-center justify-center shadow-lg animate-fade-in">
      <WifiOff className="h-4 w-4 mr-2" />
      <span>현재 오프라인 상태입니다. 네트워크 연결을 확인해주세요.</span>
    </div>
  );
}
